
export class EmploymentPlan{
  constructor(
    public id?: number,
    public empPlanStartDt?: any,
    public estimatedCompletionDt?: any,
    public clientAgreementDt?: any,
    public shortTermGoalCd?: string,
    public longTermGoalCd?: string,
    public empPlanStatusCd?:string,
    public empPlanStatusDt?: any,
    public notes?: string,
    public deleteSw?: string,
    public recordVersion?:number,
    public etEnrollmentId?: number,
    public caseClosureReasonCd?: string,
    public clientSigningStatus?: string
    //public agreementOrDeclinedDate?: any,
  ){
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/employment-plan.model.ts